//
//
//
//
//
//
//
//
//
//
//

import stepLIst from "@/components/13.comForm/steps.vue";
import CommonForm from "@/components/13.comForm/common_form";
import btnList from "@/components/15.UpLoadList/btnList.vue";
export default {
  components: {
    "step-lIst": stepLIst,
    "common-form": CommonForm,
    "btn-list": btnList
  },
  data() {
    return {
      flowStepsConfig: {
        bg: "#fff",
        padding: "15px 34px",
        size: "16px",
        numberSize: "12px",
        textSize: "",
        textTop: "30px",
        lineWidth: "2px",
        list: [
          { number: "", text: "选择问题类型", isDone: true },
          { number: "", text: "填写问题信息", isDone: true },
          { number: "", text: "填写接收信息", isActive: false, isDone: true },
          { number: "", text: "提交成功", isActive: false, isDone: false }
        ]
      },

      dataListInfor: [
        {
          title: "请确认您的信息",
          list: [
            {
              type: "input",
              title: "所属事业部：",
              placeholder: "",
              value: "朵拉事业部",
              disabled: true,
              required: false
            },
            {
              type: "input",
              title: "所属经销商：",
              placeholder: "",
              value: "[编码] 经销商名称",
              disabled: true,
              required: false
            },
            {
              type: "input",
              title: "接收人：",
              placeholder: "",
              value: "[编码] 人员名称",
              disabled: true,
              required: false
            },
            {
              type: "input",
              title: "联系方式：",
              placeholder: "",
              value: "15229741603",
              disabled: true,
              required: false
            },
            {
              type: "input",
              title: "邮箱",
              placeholder: "请输入邮箱...",
              value: "",
              disabled: false,
              required: false
            },
            {
              type: "dataTime",
              title: "期待回复的时间：",
              placeholder: "请选择时间...",
              value: "",
              disabled: false,
              required: false,
              show: false,
              cur_date: new Date(),
              min_date: new Date("2012/01/01"),
              max_date: new Date()
            }
          ]
        }
      ],

       btnList: [
        {
          text: "提交",
          type: "primary",
          url: "/CustomerServiceCode/submitSuccess"
        },
        {
          text: "返回",
          type: "danger",
          flage: "callback"
        }
      ]
    };
  },

  methods: {},
  created() {},

  mounted() {}
};
